'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Arrow = function Arrow(_ref) {
  var direction = _ref.direction,
      onClick = _ref.onClick,
      areSlideFeaturesVisible = _ref.areSlideFeaturesVisible;

  var arrowIconDirection = direction === 'next' ? 'icon-arrow-2-e' : 'icon-arrow-2-w';

  return _react2.default.createElement('div', {
    onClick: onClick,
    className: 'ac-collection-' + direction + ' ' + areSlideFeaturesVisible + ' ' + arrowIconDirection
  });
};

Arrow.propTypes = {
  direction: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  areSlideFeaturesVisible: _propTypes2.default.string
};

exports.default = Arrow;


//////////////////
// WEBPACK FOOTER
// ./lib/listings/Arrow.js
// module id = 573
// module chunks = 0